/** @jsx jsx */
import { useTheme } from "@cd2/theme/build/es6"
import { css, jsx } from "@emotion/core"
import { siteTheme } from "../providers/ThemeProvider"

export function FieldGroup({
  name,
  children,
  gap,
}: {
  name?: string
  children: React.ReactNode
  gap?: boolean
}) {
  const theme = useTheme()

  return (
    <fieldset
      css={css`
        border: 1px solid ${theme.forms.border?.color || "#DADADA"};
        padding: 8px 16px;
        border-radius: ${theme.borderRadius}px;
        margin: 0;
        ${gap &&
        css`
          display: grid;
          gap: ${siteTheme.sizes.fieldGap}px;
        `}
      `}
    >
      <legend>{name}</legend>
      {children}
    </fieldset>
  )
}
